import React from 'react';

const style = { color: 'gray' };

const HowToCloseModal = () => (
  <p style={style}>press escape or click the x to cancel</p>
);

export default HowToCloseModal;



/** WEBPACK FOOTER **
 ** ./src/components/how-to-close-modal/index.js
 **/